/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {CustomWidget2} from '../../../_metronic/partials/widgets'

export function StatoOrdini() {
  return (
    <>	
      <div className='col-xl-12'>
        <CustomWidget2 className='card-xxl-stretch mb-5 mb-xl-10' />
      </div>
    </>
  )
}
